import {
  FETCH_MAINTENANCE_DASHBOARD,
  FETCH_MAINTENANCE_DASHBOARD_SUCCESS,
  FETCH_MAINTENANCE_DASHBOARD_FAILURE,
  //
  FETCH_MAINTENANCE_REQUESTS,
  FETCH_MAINTENANCE_REQUESTS_SUCCESS,
  FETCH_MAINTENANCE_REQUESTS_FAILURE,
  //
  ADD_MAINTENANCE_REQUEST,
  ADD_MAINTENANCE_REQUEST_SUCCESS,
  ADD_MAINTENANCE_REQUEST_FAILURE,
  //
  FETCH_MAINTENANCE_REQUEST,
  FETCH_MAINTENANCE_REQUEST_SUCCESS,
  FETCH_MAINTENANCE_REQUEST_FAILURE,
  //
  EDIT_MAINTENANCE_REQUEST,
  EDIT_MAINTENANCE_REQUEST_SUCCESS,
  EDIT_MAINTENANCE_REQUEST_FAILURE,
  //
  DELETE_MAINTENANCE_REQUEST,
  DELETE_MAINTENANCE_REQUEST_SUCCESS,
  DELETE_MAINTENANCE_REQUEST_FAILURE,
  //
  UPDATE_MAINTENANCE_REQUEST_STATUS,
  UPDATE_MAINTENANCE_REQUEST_STATUS_SUCCESS,
  UPDATE_MAINTENANCE_REQUEST_STATUS_FAILURE,
  //
  FETCH_MAINTENANCE_INSPECTIONS,
  FETCH_MAINTENANCE_INSPECTIONS_SUCCESS,
  FETCH_MAINTENANCE_INSPECTIONS_FAILURE,
  //
  ADD_MAINTENANCE_INSPECTION,
  ADD_MAINTENANCE_INSPECTION_SUCCESS,
  ADD_MAINTENANCE_INSPECTION_FAILURE,
  //
  FETCH_MAINTENANCE_INSPECTION,
  FETCH_MAINTENANCE_INSPECTION_SUCCESS,
  FETCH_MAINTENANCE_INSPECTION_FAILURE,
  //
  SUBMIT_MAINTENANCE_INSPECTION,
  SUBMIT_MAINTENANCE_INSPECTION_SUCCESS,
  SUBMIT_MAINTENANCE_INSPECTION_FAILURE,
  //
  FETCH_MAINTENANCE_ASSETS,
  FETCH_MAINTENANCE_ASSETS_SUCCESS,
  FETCH_MAINTENANCE_ASSETS_FAILURE,
  //
  ADD_MAINTENANCE_ASSET,
  ADD_MAINTENANCE_ASSET_SUCCESS,
  ADD_MAINTENANCE_ASSET_FAILURE,
  //
  FETCH_MAINTENANCE_ASSET,
  FETCH_MAINTENANCE_ASSET_SUCCESS,
  FETCH_MAINTENANCE_ASSET_FAILURE,
  //
  EDIT_MAINTENANCE_ASSET,
  EDIT_MAINTENANCE_ASSET_SUCCESS,
  EDIT_MAINTENANCE_ASSET_FAILURE,
  //
  DELETE_MAINTENANCE_ASSET,
  DELETE_MAINTENANCE_ASSET_SUCCESS,
  DELETE_MAINTENANCE_ASSET_FAILURE,
  //
  SET_ASSET_ADD_EDIT_MODAL,
  //
  FETCH_MAINTENANCE_COMPLIANCE,
  FETCH_MAINTENANCE_COMPLIANCE_SUCCESS,
  FETCH_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  ADD_MAINTENANCE_COMPLIANCE,
  ADD_MAINTENANCE_COMPLIANCE_SUCCESS,
  ADD_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  FETCH_MAINTENANCE_COMPLIANCE_ITEM,
  FETCH_MAINTENANCE_COMPLIANCE_ITEM_SUCCESS,
  FETCH_MAINTENANCE_COMPLIANCE_ITEM_FAILURE,
  //
  EDIT_MAINTENANCE_COMPLIANCE,
  EDIT_MAINTENANCE_COMPLIANCE_SUCCESS,
  EDIT_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  DELETE_MAINTENANCE_COMPLIANCE,
  DELETE_MAINTENANCE_COMPLIANCE_SUCCESS,
  DELETE_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  FETCH_MAINTENANCE_SCHEDULES,
  FETCH_MAINTENANCE_SCHEDULES_SUCCESS,
  FETCH_MAINTENANCE_SCHEDULES_FAILURE,
  //
  ADD_MAINTENANCE_SCHEDULE,
  ADD_MAINTENANCE_SCHEDULE_SUCCESS,
  ADD_MAINTENANCE_SCHEDULE_FAILURE,
  //
  EDIT_MAINTENANCE_SCHEDULE,
  EDIT_MAINTENANCE_SCHEDULE_SUCCESS,
  EDIT_MAINTENANCE_SCHEDULE_FAILURE,
  //
  DELETE_MAINTENANCE_SCHEDULE,
  DELETE_MAINTENANCE_SCHEDULE_SUCCESS,
  DELETE_MAINTENANCE_SCHEDULE_FAILURE,
  //
  GET_MAINTENANCE_SCHEDULE,
  GET_MAINTENANCE_SCHEDULE_SUCCESS,
  GET_MAINTENANCE_SCHEDULE_FAILURE,
  SET_SCHEDULE_ADD_EDIT_MODAL,
  //
  ACTIVATE_ALL_PRESETS,
  ACTIVATE_ALL_PRESETS_SUCCESS,
  ACTIVATE_ALL_PRESETS_FAILURE,
  //
  FETCH_MAINTENANCE_LOCATION_SETTING,
  FETCH_MAINTENANCE_LOCATION_SETTING_SUCCESS,
  FETCH_MAINTENANCE_LOCATION_SETTING_FAILURE,
  //
  SAVE_MAINTENANCE_LOCATION_SETTING,
  SAVE_MAINTENANCE_LOCATION_SETTING_SUCCESS,
  SAVE_MAINTENANCE_LOCATION_SETTING_FAILURE,
  //
  FETCH_INSPECTION_TEMPLATES,
  FETCH_INSPECTION_TEMPLATES_SUCCESS,
  FETCH_INSPECTION_TEMPLATES_FAILURE,
  //
  ADD_INSPECTION_TEMPLATE,
  ADD_INSPECTION_TEMPLATE_SUCCESS,
  ADD_INSPECTION_TEMPLATE_FAILURE,
  //
  EDIT_INSPECTION_TEMPLATE,
  EDIT_INSPECTION_TEMPLATE_SUCCESS,
  EDIT_INSPECTION_TEMPLATE_FAILURE,
  //
  DELETE_INSPECTION_TEMPLATE,
  DELETE_INSPECTION_TEMPLATE_SUCCESS,
  DELETE_INSPECTION_TEMPLATE_FAILURE,
  //
  CLONE_INSPECTION_TEMPLATE,
  CLONE_INSPECTION_TEMPLATE_SUCCESS,
  CLONE_INSPECTION_TEMPLATE_FAILURE,
  //
  SET_TEMPLATE_ADD_EDIT_MODAL,
  //
  ADD_INSPECTION_FROM_TEMPLATE,
  ADD_INSPECTION_FROM_TEMPLATE_SUCCESS,
  ADD_INSPECTION_FROM_TEMPLATE_FAILURE,
  //
  FETCH_CQC_REPORT,
  FETCH_CQC_REPORT_SUCCESS,
  FETCH_CQC_REPORT_FAILURE,
  //
  FETCH_INSPECTION_REPORT,
  FETCH_INSPECTION_REPORT_SUCCESS,
  FETCH_INSPECTION_REPORT_FAILURE,
  //
  SET_REQUEST_CREATE_MODAL,
  //
  FETCH_MAINTENANCE_QUOTES,
  FETCH_MAINTENANCE_QUOTES_SUCCESS,
  FETCH_MAINTENANCE_QUOTES_FAILURE,
  FETCH_MAINTENANCE_QUOTE,
  FETCH_MAINTENANCE_QUOTE_SUCCESS,
  FETCH_MAINTENANCE_QUOTE_FAILURE,
  ADD_MAINTENANCE_QUOTE,
  ADD_MAINTENANCE_QUOTE_SUCCESS,
  ADD_MAINTENANCE_QUOTE_FAILURE,
  EDIT_MAINTENANCE_QUOTE,
  EDIT_MAINTENANCE_QUOTE_SUCCESS,
  EDIT_MAINTENANCE_QUOTE_FAILURE,
  DELETE_MAINTENANCE_QUOTE,
  DELETE_MAINTENANCE_QUOTE_SUCCESS,
  DELETE_MAINTENANCE_QUOTE_FAILURE,
  ACCEPT_MAINTENANCE_QUOTE,
  ACCEPT_MAINTENANCE_QUOTE_SUCCESS,
  ACCEPT_MAINTENANCE_QUOTE_FAILURE,
  //
  FETCH_COMPLIANCE_MATRIX,
  FETCH_COMPLIANCE_MATRIX_SUCCESS,
  FETCH_COMPLIANCE_MATRIX_FAILURE,
  FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT,
  FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_SUCCESS,
  FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_FAILURE,
  FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  //
  ADD_MAINTENANCE_INVOICE,
  ADD_MAINTENANCE_INVOICE_SUCCESS,
  ADD_MAINTENANCE_INVOICE_FAILURE,
  EDIT_MAINTENANCE_INVOICE,
  EDIT_MAINTENANCE_INVOICE_SUCCESS,
  EDIT_MAINTENANCE_INVOICE_FAILURE,
  DELETE_MAINTENANCE_INVOICE,
  DELETE_MAINTENANCE_INVOICE_SUCCESS,
  DELETE_MAINTENANCE_INVOICE_FAILURE,
  //
  UPDATE_INSPECTION_STATUS,
  UPDATE_INSPECTION_STATUS_SUCCESS,
  UPDATE_INSPECTION_STATUS_FAILURE,
  //
  APPROVE_INSPECTION,
  APPROVE_INSPECTION_SUCCESS,
  APPROVE_INSPECTION_FAILURE,
  //
  SKIP_INSPECTION_ITEMS,
  SKIP_INSPECTION_ITEMS_SUCCESS,
  SKIP_INSPECTION_ITEMS_FAILURE,
  //
  EDIT_MAINTENANCE_INSPECTION,
  EDIT_MAINTENANCE_INSPECTION_SUCCESS,
  EDIT_MAINTENANCE_INSPECTION_FAILURE,
} from "./constants";

export const fetchMaintenanceDashboard = (payload) => ({
  type: FETCH_MAINTENANCE_DASHBOARD,
  payload,
});
export const fetchMaintenanceDashboardSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_DASHBOARD_SUCCESS,
  payload,
});
export const fetchMaintenanceDashboardFailure = (payload) => ({
  type: FETCH_MAINTENANCE_DASHBOARD_FAILURE,
  payload,
});

export const fetchMaintenanceRequests = (payload) => ({
  type: FETCH_MAINTENANCE_REQUESTS,
  payload,
});
export const fetchMaintenanceRequestsSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_REQUESTS_SUCCESS,
  payload,
});
export const fetchMaintenanceRequestsFailure = (payload) => ({
  type: FETCH_MAINTENANCE_REQUESTS_FAILURE,
  payload,
});

export const addMaintenanceRequest = (payload, onSuccess) => ({
  type: ADD_MAINTENANCE_REQUEST,
  payload,
  onSuccess,
});
export const addMaintenanceRequestSuccess = (payload) => ({
  type: ADD_MAINTENANCE_REQUEST_SUCCESS,
  payload,
});
export const addMaintenanceRequestFailure = (payload) => ({
  type: ADD_MAINTENANCE_REQUEST_FAILURE,
  payload,
});

export const fetchMaintenanceRequest = (payload) => ({
  type: FETCH_MAINTENANCE_REQUEST,
  payload,
});
export const fetchMaintenanceRequestSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_REQUEST_SUCCESS,
  payload,
});
export const fetchMaintenanceRequestFailure = (payload) => ({
  type: FETCH_MAINTENANCE_REQUEST_FAILURE,
  payload,
});

export const editMaintenanceRequest = (payload) => ({
  type: EDIT_MAINTENANCE_REQUEST,
  payload,
});
export const editMaintenanceRequestSuccess = (payload) => ({
  type: EDIT_MAINTENANCE_REQUEST_SUCCESS,
  payload,
});
export const editMaintenanceRequestFailure = (payload) => ({
  type: EDIT_MAINTENANCE_REQUEST_FAILURE,
  payload,
});

export const deleteMaintenanceRequest = (payload, onDelete) => ({
  type: DELETE_MAINTENANCE_REQUEST,
  payload,
  onDelete,
});
export const deleteMaintenanceRequestSuccess = (payload) => ({
  type: DELETE_MAINTENANCE_REQUEST_SUCCESS,
  payload,
});
export const deleteMaintenanceRequestFailure = (payload) => ({
  type: DELETE_MAINTENANCE_REQUEST_FAILURE,
  payload,
});

export const updateMaintenanceRequestStatus = (payload, onSuccess) => ({
  type: UPDATE_MAINTENANCE_REQUEST_STATUS,
  payload,
  onSuccess,
});
export const updateMaintenanceRequestStatusSuccess = (payload) => ({
  type: UPDATE_MAINTENANCE_REQUEST_STATUS_SUCCESS,
  payload,
});
export const updateMaintenanceRequestStatusFailure = (payload) => ({
  type: UPDATE_MAINTENANCE_REQUEST_STATUS_FAILURE,
  payload,
});

export const fetchMaintenanceInspections = (payload) => ({
  type: FETCH_MAINTENANCE_INSPECTIONS,
  payload,
});
export const fetchMaintenanceInspectionsSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_INSPECTIONS_SUCCESS,
  payload,
});
export const fetchMaintenanceInspectionsFailure = (payload) => ({
  type: FETCH_MAINTENANCE_INSPECTIONS_FAILURE,
  payload,
});

export const addMaintenanceInspection = (payload) => ({
  type: ADD_MAINTENANCE_INSPECTION,
  payload,
});
export const addMaintenanceInspectionSuccess = (payload) => ({
  type: ADD_MAINTENANCE_INSPECTION_SUCCESS,
  payload,
});
export const addMaintenanceInspectionFailure = (payload) => ({
  type: ADD_MAINTENANCE_INSPECTION_FAILURE,
  payload,
});

export const fetchMaintenanceInspection = (payload) => ({
  type: FETCH_MAINTENANCE_INSPECTION,
  payload,
});
export const fetchMaintenanceInspectionSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_INSPECTION_SUCCESS,
  payload,
});
export const fetchMaintenanceInspectionFailure = (payload) => ({
  type: FETCH_MAINTENANCE_INSPECTION_FAILURE,
  payload,
});

export const submitMaintenanceInspection = (payload) => ({
  type: SUBMIT_MAINTENANCE_INSPECTION,
  payload,
});
export const submitMaintenanceInspectionSuccess = (payload) => ({
  type: SUBMIT_MAINTENANCE_INSPECTION_SUCCESS,
  payload,
});
export const submitMaintenanceInspectionFailure = (payload) => ({
  type: SUBMIT_MAINTENANCE_INSPECTION_FAILURE,
  payload,
});

export const fetchMaintenanceAssets = (payload) => ({
  type: FETCH_MAINTENANCE_ASSETS,
  payload,
});
export const fetchMaintenanceAssetsSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_ASSETS_SUCCESS,
  payload,
});
export const fetchMaintenanceAssetsFailure = (payload) => ({
  type: FETCH_MAINTENANCE_ASSETS_FAILURE,
  payload,
});

export const addMaintenanceAsset = (payload) => ({
  type: ADD_MAINTENANCE_ASSET,
  payload,
});
export const addMaintenanceAssetSuccess = (payload) => ({
  type: ADD_MAINTENANCE_ASSET_SUCCESS,
  payload,
});
export const addMaintenanceAssetFailure = (payload) => ({
  type: ADD_MAINTENANCE_ASSET_FAILURE,
  payload,
});

export const fetchMaintenanceAsset = (payload) => ({
  type: FETCH_MAINTENANCE_ASSET,
  payload,
});
export const fetchMaintenanceAssetSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_ASSET_SUCCESS,
  payload,
});
export const fetchMaintenanceAssetFailure = (payload) => ({
  type: FETCH_MAINTENANCE_ASSET_FAILURE,
  payload,
});

export const editMaintenanceAsset = (payload) => ({
  type: EDIT_MAINTENANCE_ASSET,
  payload,
});
export const editMaintenanceAssetSuccess = (payload) => ({
  type: EDIT_MAINTENANCE_ASSET_SUCCESS,
  payload,
});
export const editMaintenanceAssetFailure = (payload) => ({
  type: EDIT_MAINTENANCE_ASSET_FAILURE,
  payload,
});

export const deleteMaintenanceAsset = (payload, onDelete) => ({
  type: DELETE_MAINTENANCE_ASSET,
  payload,
  onDelete,
});
export const deleteMaintenanceAssetSuccess = (payload) => ({
  type: DELETE_MAINTENANCE_ASSET_SUCCESS,
  payload,
});
export const deleteMaintenanceAssetFailure = (payload) => ({
  type: DELETE_MAINTENANCE_ASSET_FAILURE,
  payload,
});

export const setAssetAddEditModal = (payload) => ({
  type: SET_ASSET_ADD_EDIT_MODAL,
  payload,
});

export const fetchMaintenanceCompliance = (payload) => ({
  type: FETCH_MAINTENANCE_COMPLIANCE,
  payload,
});
export const fetchMaintenanceComplianceSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_COMPLIANCE_SUCCESS,
  payload,
});
export const fetchMaintenanceComplianceFailure = (payload) => ({
  type: FETCH_MAINTENANCE_COMPLIANCE_FAILURE,
  payload,
});

export const addMaintenanceCompliance = (payload) => ({
  type: ADD_MAINTENANCE_COMPLIANCE,
  payload,
});
export const addMaintenanceComplianceSuccess = (payload) => ({
  type: ADD_MAINTENANCE_COMPLIANCE_SUCCESS,
  payload,
});
export const addMaintenanceComplianceFailure = (payload) => ({
  type: ADD_MAINTENANCE_COMPLIANCE_FAILURE,
  payload,
});

export const fetchMaintenanceComplianceItem = (payload) => ({
  type: FETCH_MAINTENANCE_COMPLIANCE_ITEM,
  payload,
});
export const fetchMaintenanceComplianceItemSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_COMPLIANCE_ITEM_SUCCESS,
  payload,
});
export const fetchMaintenanceComplianceItemFailure = (payload) => ({
  type: FETCH_MAINTENANCE_COMPLIANCE_ITEM_FAILURE,
  payload,
});

export const editMaintenanceCompliance = (payload) => ({
  type: EDIT_MAINTENANCE_COMPLIANCE,
  payload,
});
export const editMaintenanceComplianceSuccess = (payload) => ({
  type: EDIT_MAINTENANCE_COMPLIANCE_SUCCESS,
  payload,
});
export const editMaintenanceComplianceFailure = (payload) => ({
  type: EDIT_MAINTENANCE_COMPLIANCE_FAILURE,
  payload,
});

export const deleteMaintenanceCompliance = (payload, onDelete) => ({
  type: DELETE_MAINTENANCE_COMPLIANCE,
  payload,
  onDelete,
});
export const deleteMaintenanceComplianceSuccess = (payload) => ({
  type: DELETE_MAINTENANCE_COMPLIANCE_SUCCESS,
  payload,
});
export const deleteMaintenanceComplianceFailure = (payload) => ({
  type: DELETE_MAINTENANCE_COMPLIANCE_FAILURE,
  payload,
});

export const fetchMaintenanceSchedules = (payload) => ({
  type: FETCH_MAINTENANCE_SCHEDULES,
  payload,
});
export const fetchMaintenanceSchedulesSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_SCHEDULES_SUCCESS,
  payload,
});
export const fetchMaintenanceSchedulesFailure = (payload) => ({
  type: FETCH_MAINTENANCE_SCHEDULES_FAILURE,
  payload,
});

export const addMaintenanceSchedule = (payload) => ({
  type: ADD_MAINTENANCE_SCHEDULE,
  payload,
});
export const addMaintenanceScheduleSuccess = (payload) => ({
  type: ADD_MAINTENANCE_SCHEDULE_SUCCESS,
  payload,
});
export const addMaintenanceScheduleFailure = (payload) => ({
  type: ADD_MAINTENANCE_SCHEDULE_FAILURE,
  payload,
});

export const editMaintenanceSchedule = (payload, onSuccess) => ({
  type: EDIT_MAINTENANCE_SCHEDULE,
  payload,
  onSuccess,
});
export const editMaintenanceScheduleSuccess = (payload) => ({
  type: EDIT_MAINTENANCE_SCHEDULE_SUCCESS,
  payload,
});
export const editMaintenanceScheduleFailure = (payload) => ({
  type: EDIT_MAINTENANCE_SCHEDULE_FAILURE,
  payload,
});

export const deleteMaintenanceSchedule = (payload, onDelete) => ({
  type: DELETE_MAINTENANCE_SCHEDULE,
  payload,
  onDelete,
});
export const deleteMaintenanceScheduleSuccess = (payload) => ({
  type: DELETE_MAINTENANCE_SCHEDULE_SUCCESS,
  payload,
});
export const deleteMaintenanceScheduleFailure = (payload) => ({
  type: DELETE_MAINTENANCE_SCHEDULE_FAILURE,
  payload,
});

export const getMaintenanceSchedule = (payload) => ({
  type: GET_MAINTENANCE_SCHEDULE,
  payload,
});
export const getMaintenanceScheduleSuccess = (payload) => ({
  type: GET_MAINTENANCE_SCHEDULE_SUCCESS,
  payload,
});
export const getMaintenanceScheduleFailure = (payload) => ({
  type: GET_MAINTENANCE_SCHEDULE_FAILURE,
  payload,
});

export const setScheduleAddEditModal = (payload) => ({
  type: SET_SCHEDULE_ADD_EDIT_MODAL,
  payload,
});

export const activateAllPresets = (payload) => ({
  type: ACTIVATE_ALL_PRESETS,
  payload,
});
export const activateAllPresetsSuccess = (payload) => ({
  type: ACTIVATE_ALL_PRESETS_SUCCESS,
  payload,
});
export const activateAllPresetsFailure = (payload) => ({
  type: ACTIVATE_ALL_PRESETS_FAILURE,
  payload,
});

export const fetchMaintenanceLocationSetting = (payload) => ({
  type: FETCH_MAINTENANCE_LOCATION_SETTING,
  payload,
});
export const fetchMaintenanceLocationSettingSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_LOCATION_SETTING_SUCCESS,
  payload,
});
export const fetchMaintenanceLocationSettingFailure = (payload) => ({
  type: FETCH_MAINTENANCE_LOCATION_SETTING_FAILURE,
  payload,
});

export const saveMaintenanceLocationSetting = (payload) => ({
  type: SAVE_MAINTENANCE_LOCATION_SETTING,
  payload,
});
export const saveMaintenanceLocationSettingSuccess = (payload) => ({
  type: SAVE_MAINTENANCE_LOCATION_SETTING_SUCCESS,
  payload,
});
export const saveMaintenanceLocationSettingFailure = (payload) => ({
  type: SAVE_MAINTENANCE_LOCATION_SETTING_FAILURE,
  payload,
});

export const fetchInspectionTemplates = (payload) => ({
  type: FETCH_INSPECTION_TEMPLATES,
  payload,
});
export const fetchInspectionTemplatesSuccess = (payload) => ({
  type: FETCH_INSPECTION_TEMPLATES_SUCCESS,
  payload,
});
export const fetchInspectionTemplatesFailure = (payload) => ({
  type: FETCH_INSPECTION_TEMPLATES_FAILURE,
  payload,
});

export const addInspectionTemplate = (payload) => ({
  type: ADD_INSPECTION_TEMPLATE,
  payload,
});
export const addInspectionTemplateSuccess = (payload) => ({
  type: ADD_INSPECTION_TEMPLATE_SUCCESS,
  payload,
});
export const addInspectionTemplateFailure = (payload) => ({
  type: ADD_INSPECTION_TEMPLATE_FAILURE,
  payload,
});

export const editInspectionTemplate = (payload) => ({
  type: EDIT_INSPECTION_TEMPLATE,
  payload,
});
export const editInspectionTemplateSuccess = (payload) => ({
  type: EDIT_INSPECTION_TEMPLATE_SUCCESS,
  payload,
});
export const editInspectionTemplateFailure = (payload) => ({
  type: EDIT_INSPECTION_TEMPLATE_FAILURE,
  payload,
});

export const deleteInspectionTemplate = (payload, onDelete) => ({
  type: DELETE_INSPECTION_TEMPLATE,
  payload,
  onDelete,
});
export const deleteInspectionTemplateSuccess = (payload) => ({
  type: DELETE_INSPECTION_TEMPLATE_SUCCESS,
  payload,
});
export const deleteInspectionTemplateFailure = (payload) => ({
  type: DELETE_INSPECTION_TEMPLATE_FAILURE,
  payload,
});

export const cloneInspectionTemplate = (data, onSuccess) => ({
  type: CLONE_INSPECTION_TEMPLATE,
  payload: { data, onSuccess },
});
export const cloneInspectionTemplateSuccess = (payload) => ({
  type: CLONE_INSPECTION_TEMPLATE_SUCCESS,
  payload,
});
export const cloneInspectionTemplateFailure = (payload) => ({
  type: CLONE_INSPECTION_TEMPLATE_FAILURE,
  payload,
});

export const setTemplateAddEditModal = (payload) => ({
  type: SET_TEMPLATE_ADD_EDIT_MODAL,
  payload,
});

export const setRequestCreateModal = (payload) => ({
  type: SET_REQUEST_CREATE_MODAL,
  payload,
});

// Quotes
export const fetchQuotes = (payload) => ({
  type: FETCH_MAINTENANCE_QUOTES,
  payload,
});
export const fetchQuotesSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_QUOTES_SUCCESS,
  payload,
});
export const fetchQuotesFailure = (payload) => ({
  type: FETCH_MAINTENANCE_QUOTES_FAILURE,
  payload,
});

export const fetchQuote = (payload) => ({
  type: FETCH_MAINTENANCE_QUOTE,
  payload,
});
export const fetchQuoteSuccess = (payload) => ({
  type: FETCH_MAINTENANCE_QUOTE_SUCCESS,
  payload,
});
export const fetchQuoteFailure = (payload) => ({
  type: FETCH_MAINTENANCE_QUOTE_FAILURE,
  payload,
});

export const addQuote = (payload, onSuccess) => ({
  type: ADD_MAINTENANCE_QUOTE,
  payload,
  onSuccess,
});
export const addQuoteSuccess = (payload) => ({
  type: ADD_MAINTENANCE_QUOTE_SUCCESS,
  payload,
});
export const addQuoteFailure = (payload) => ({
  type: ADD_MAINTENANCE_QUOTE_FAILURE,
  payload,
});

export const editQuote = (payload) => ({
  type: EDIT_MAINTENANCE_QUOTE,
  payload,
});
export const editQuoteSuccess = (payload) => ({
  type: EDIT_MAINTENANCE_QUOTE_SUCCESS,
  payload,
});
export const editQuoteFailure = (payload) => ({
  type: EDIT_MAINTENANCE_QUOTE_FAILURE,
  payload,
});

export const deleteQuote = (payload, onDelete) => ({
  type: DELETE_MAINTENANCE_QUOTE,
  payload,
  onDelete,
});
export const deleteQuoteSuccess = (payload) => ({
  type: DELETE_MAINTENANCE_QUOTE_SUCCESS,
  payload,
});
export const deleteQuoteFailure = (payload) => ({
  type: DELETE_MAINTENANCE_QUOTE_FAILURE,
  payload,
});

export const acceptQuote = (payload, onSuccess) => ({
  type: ACCEPT_MAINTENANCE_QUOTE,
  payload,
  onSuccess,
});
export const acceptQuoteSuccess = (payload) => ({
  type: ACCEPT_MAINTENANCE_QUOTE_SUCCESS,
  payload,
});
export const acceptQuoteFailure = (payload) => ({
  type: ACCEPT_MAINTENANCE_QUOTE_FAILURE,
  payload,
});

export const addInspectionFromTemplate = (data, onSuccess) => ({
  type: ADD_INSPECTION_FROM_TEMPLATE,
  payload: { data, onSuccess },
});
export const addInspectionFromTemplateSuccess = (payload) => ({
  type: ADD_INSPECTION_FROM_TEMPLATE_SUCCESS,
  payload,
});
export const addInspectionFromTemplateFailure = (payload) => ({
  type: ADD_INSPECTION_FROM_TEMPLATE_FAILURE,
  payload,
});

export const fetchCqcReport = (payload) => ({
  type: FETCH_CQC_REPORT,
  payload,
});
export const fetchCqcReportSuccess = (payload) => ({
  type: FETCH_CQC_REPORT_SUCCESS,
  payload,
});
export const fetchCqcReportFailure = (payload) => ({
  type: FETCH_CQC_REPORT_FAILURE,
  payload,
});

export const fetchInspectionReport = (payload) => ({
  type: FETCH_INSPECTION_REPORT,
  payload,
});
export const fetchInspectionReportSuccess = (payload) => ({
  type: FETCH_INSPECTION_REPORT_SUCCESS,
  payload,
});
export const fetchInspectionReportFailure = (payload) => ({
  type: FETCH_INSPECTION_REPORT_FAILURE,
  payload,
});

export const fetchComplianceMatrix = (payload) => ({
  type: FETCH_COMPLIANCE_MATRIX,
  payload,
});
export const fetchComplianceMatrixSuccess = (payload) => ({
  type: FETCH_COMPLIANCE_MATRIX_SUCCESS,
  payload,
});
export const fetchComplianceMatrixFailure = (payload) => ({
  type: FETCH_COMPLIANCE_MATRIX_FAILURE,
  payload,
});

export const fetchScheduledCompletedChecksReport = (payload) => ({
  type: FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT,
  payload,
});
export const fetchScheduledCompletedChecksReportSuccess = (payload) => ({
  type: FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_SUCCESS,
  payload,
});
export const fetchScheduledCompletedChecksReportFailure = (payload) => ({
  type: FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_FAILURE,
  payload,
});

export const fetchMonthlyScheduleChecklistReport = (payload) => ({
  type: FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const fetchMonthlyScheduleChecklistReportSuccess = (payload) => ({
  type: FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const fetchMonthlyScheduleChecklistReportFailure = (payload) => ({
  type: FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const fetchWeeklyScheduleChecklistReport = (payload) => ({
  type: FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const fetchWeeklyScheduleChecklistReportSuccess = (payload) => ({
  type: FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const fetchWeeklyScheduleChecklistReportFailure = (payload) => ({
  type: FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const fetchQuarterlyScheduleChecklistReport = (payload) => ({
  type: FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const fetchQuarterlyScheduleChecklistReportSuccess = (payload) => ({
  type: FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const fetchQuarterlyScheduleChecklistReportFailure = (payload) => ({
  type: FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const fetchAnnualScheduleChecklistReport = (payload) => ({
  type: FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const fetchAnnualScheduleChecklistReportSuccess = (payload) => ({
  type: FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const fetchAnnualScheduleChecklistReportFailure = (payload) => ({
  type: FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const exportMonthlyScheduleChecklistReport = (payload) => ({
  type: EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const exportMonthlyScheduleChecklistReportSuccess = (payload) => ({
  type: EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const exportMonthlyScheduleChecklistReportFailure = (payload) => ({
  type: EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const exportWeeklyScheduleChecklistReport = (payload) => ({
  type: EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const exportWeeklyScheduleChecklistReportSuccess = (payload) => ({
  type: EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const exportWeeklyScheduleChecklistReportFailure = (payload) => ({
  type: EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const exportQuarterlyScheduleChecklistReport = (payload) => ({
  type: EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const exportQuarterlyScheduleChecklistReportSuccess = (payload) => ({
  type: EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const exportQuarterlyScheduleChecklistReportFailure = (payload) => ({
  type: EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const exportAnnualScheduleChecklistReport = (payload) => ({
  type: EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const exportAnnualScheduleChecklistReportSuccess = (payload) => ({
  type: EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const exportAnnualScheduleChecklistReportFailure = (payload) => ({
  type: EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

export const fetchDailyScheduleChecklistReport = (payload) => ({
  type: FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT,
  payload,
});
export const fetchDailyScheduleChecklistReportSuccess = (payload) => ({
  type: FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  payload,
});
export const fetchDailyScheduleChecklistReportFailure = (payload) => ({
  type: FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  payload,
});

// Invoice
export const addMaintenanceInvoice = (payload) => ({
  type: ADD_MAINTENANCE_INVOICE,
  payload,
});
export const addMaintenanceInvoiceSuccess = (payload) => ({
  type: ADD_MAINTENANCE_INVOICE_SUCCESS,
  payload,
});
export const addMaintenanceInvoiceFailure = (payload) => ({
  type: ADD_MAINTENANCE_INVOICE_FAILURE,
  payload,
});

export const editMaintenanceInvoice = (payload) => ({
  type: EDIT_MAINTENANCE_INVOICE,
  payload,
});
export const editMaintenanceInvoiceSuccess = (payload) => ({
  type: EDIT_MAINTENANCE_INVOICE_SUCCESS,
  payload,
});
export const editMaintenanceInvoiceFailure = (payload) => ({
  type: EDIT_MAINTENANCE_INVOICE_FAILURE,
  payload,
});

export const deleteMaintenanceInvoice = (payload, onDelete) => ({
  type: DELETE_MAINTENANCE_INVOICE,
  payload,
  onDelete,
});
export const deleteMaintenanceInvoiceSuccess = (payload) => ({
  type: DELETE_MAINTENANCE_INVOICE_SUCCESS,
  payload,
});
export const deleteMaintenanceInvoiceFailure = (payload) => ({
  type: DELETE_MAINTENANCE_INVOICE_FAILURE,
  payload,
});

export const updateInspectionStatus = (payload, onSuccess) => ({
  type: UPDATE_INSPECTION_STATUS,
  payload,
  onSuccess,
});
export const updateInspectionStatusSuccess = (payload) => ({
  type: UPDATE_INSPECTION_STATUS_SUCCESS,
  payload,
});
export const updateInspectionStatusFailure = (payload) => ({
  type: UPDATE_INSPECTION_STATUS_FAILURE,
  payload,
});

export const approveInspection = (payload, onSuccess) => ({
  type: APPROVE_INSPECTION,
  payload,
  onSuccess,
});
export const approveInspectionSuccess = (payload) => ({
  type: APPROVE_INSPECTION_SUCCESS,
  payload,
});
export const approveInspectionFailure = (payload) => ({
  type: APPROVE_INSPECTION_FAILURE,
  payload,
});

export const skipInspectionItems = (payload, onSuccess) => ({
  type: SKIP_INSPECTION_ITEMS,
  payload,
  onSuccess,
});
export const skipInspectionItemsSuccess = (payload) => ({
  type: SKIP_INSPECTION_ITEMS_SUCCESS,
  payload,
});
export const skipInspectionItemsFailure = (payload) => ({
  type: SKIP_INSPECTION_ITEMS_FAILURE,
  payload,
});

export const editMaintenanceInspection = (payload, onSuccess) => ({
  type: EDIT_MAINTENANCE_INSPECTION,
  payload,
  onSuccess,
});
export const editMaintenanceInspectionSuccess = (payload) => ({
  type: EDIT_MAINTENANCE_INSPECTION_SUCCESS,
  payload,
});
export const editMaintenanceInspectionFailure = (payload) => ({
  type: EDIT_MAINTENANCE_INSPECTION_FAILURE,
  payload,
});
